import React, { Fragment } from 'react';
import { Header, Segment, Grid, Table, Loader, Divider, Icon, Popup, Form } from 'semantic-ui-react';
import { PieChart, Pie, Tooltip, Cell, Legend } from 'recharts';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { ToastContainer } from 'react-toastify';
import { statisticColors as colors, center, legendStyle, colorss } from '../../Statistics/util';
import { fetchMarks } from '../../Lookups/util';
import { IconHeader } from '../ProfessorInputGrades/css';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class CourseStatistics extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            chartData: [],
            dataa: [],
            loading: true,
            studyProgramBasics: [],
            studyProgramBasicId: null,
        };

        this.getData = this.getData.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        let obj = {};
        axios.post((localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator' || (localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja')) ?
            `study-programs/basic/${localStorage.getItem('orgUnit')}`
            : 'study-programs/basic', { ...obj })
            .then(res => {
                const studyProgramBasics = res.data.map((el) => ({
                    ...el,
                    value: el.studyProgramBasic.id,
                    key: el.studyProgramBasic.id,
                    text: el.studyProgramBasic.name + (el.studyProgramBasic.comment !== null ? ' (' + el.studyProgramBasic.comment + ')' : ''),
                    description: this.state.orgUnitFilter ? el.organizationalUnit.name : el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].displayName : ''
                })).filter(e => e.studyProgramBasic.archived === false);

                this.setState({ studyProgramBasics });
            })
            .catch(err => {
                console.log('Failed to fetch study program basics. ', err);
            });
        this.getData(0);
    }

    getData(studyProgramBasicId) {
        this.setState({ loading: true });
        axios.get((localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator' || (localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja')) ?
            `exams/course-statistics/${this.props.location.state.academicYear}/${this.props.location.state.semester}/${this.props.location.state.courseImplementationId}/${localStorage.getItem('orgUnit')}/${studyProgramBasicId}`
            : `exams/course-statistics/${this.props.location.state.academicYear}/${this.props.location.state.semester}/${this.props.location.state.courseImplementationId}/${studyProgramBasicId}`)
            .then(res => {
                this.setState({
                    loading: false,
                    dataa: res.data
                });
                if (res.data.length) {
                    const chartData = [
                        {
                            displayName: '5 (pet)',
                            count: res.data[0].numberOfFs
                        },
                        {
                            displayName: '6 (šest)',
                            count: res.data[0].numberOfEs
                        },
                        {
                            displayName: '7 (sedam)',
                            count: res.data[0].numberOfDs
                        },
                        {
                            displayName: '8 (osam)',
                            count: res.data[0].numberOfCs
                        },
                        {
                            displayName: '9 (devet)',
                            count: res.data[0].numberOfBs
                        },
                        {
                            displayName: '10 (deset)',
                            count: res.data[0].numberOfAs
                        },
                        {
                            displayName: 'nije ocijenjen/nije pristupio',
                            count: res.data[0].numberOfNONPs
                        }
                    ];
                    this.setState({
                        chartData
                    });
                }
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
        if (value === '') {
            this.getData(0);
        } else {
            this.getData(value);
        }
    }

    render() {
        const {
            dataa, chartData
        } = this.state;
        return (
            <div>
                <Header as="h1"> <FormattedMessage id="professorStatistics.statistics" /></Header>
                <Segment.Group raised style={{ backgroundColor: 'white' }}>
                    <Segment clearing>
                        <Header as="h3">
                            <Header.Content>
                                {this.props.location.state.courseImplementationName}
                            </Header.Content>
                            <Header style={IconHeader} floated="right" >
                                <Icon />
                                <Popup
                                    trigger={<Icon
                                        link
                                        circular
                                        basic="true"
                                        floated="right"
                                        name="arrow left"
                                        onClick={() => window.history.go(-1)}
                                    />}
                                    content={<FormattedMessage id="common.back" />}
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                            <Header.Subheader><FormattedMessage id="professorStatistics.courseName" /></Header.Subheader>
                        </Header>
                    </Segment>
                    <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <Form.Dropdown
                                        label="Studijski program"
                                        clearable
                                        placeholder="Odaberite studijski program"
                                        options={this.state.studyProgramBasics}
                                        onChange={this.handleInputChange}
                                        name="studyProgramBasicId"
                                        value={this.state.studyProgramBasicId}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Field />
                            </Form.Group>
                        </Form>
                    </Segment>
                    <Segment>
                        <Grid columns="equal" centered className="stackable">
                            <Grid.Row streched>
                                <Grid.Column>
                                    <Divider horizontal>
                                        <Header as="h4"><FormattedMessage id="professorStatistics.tableShow" /><br />
                                        </Header>
                                    </Divider>
                                    {this.state.loading ? <Segment><div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div></Segment> :
                                        dataa.length ? <div>
                                            <Table celled selectable compact>
                                                <Table.Header>
                                                    <Table.Row>
                                                        <Table.HeaderCell>
                                                            <FormattedMessage id="common.grade" />
                                                        </Table.HeaderCell>
                                                        <Table.HeaderCell>
                                                            <FormattedMessage id="professorInputGrades.gradedStudentsNumber" />
                                                        </Table.HeaderCell>

                                                    </Table.Row>
                                                </Table.Header>
                                                <Table.Body>
                                                    {dataa[0].numberOfFs !== 0 && <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.five" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfFs}
                                                        </Table.Cell>
                                                    </Table.Row>}
                                                    <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.six" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfEs}
                                                        </Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.seven" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfDs}
                                                        </Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.eight" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfCs}
                                                        </Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.nine" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfBs}
                                                        </Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.ten" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfAs}
                                                        </Table.Cell>
                                                    </Table.Row>
                                                    {dataa[0].numberOfNONPs !== 0 && <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.nonp" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfNONPs}
                                                        </Table.Cell>
                                                    </Table.Row>}
                                                    {dataa[0].numberOfNONPs === 0 && <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.np" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfNONPs}
                                                        </Table.Cell>
                                                    </Table.Row>}
                                                    {dataa[0].numberOfNONPs === 0 && <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.na" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfNAs}
                                                        </Table.Cell>
                                                    </Table.Row>}
                                                    {dataa[0].numberOfIOs !== 0 && <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.io" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfIOs}
                                                        </Table.Cell>
                                                    </Table.Row>}
                                                    {dataa[0].numberOfNZs !== 0 && <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.nz" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfNZs}
                                                        </Table.Cell>
                                                    </Table.Row>}
                                                    {dataa[0].numberOfZs !== 0 && <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.z" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfZs}
                                                        </Table.Cell>
                                                    </Table.Row>}
                                                    {dataa[0].numberOfNOs !== 0 && <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.no" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfNOs}
                                                        </Table.Cell>
                                                    </Table.Row>}
                                                    {dataa[0].numberOfUOs !== 0 && <Table.Row >
                                                        <Table.Cell verticalAlign="middle">
                                                            <FormattedMessage id="professorStatistics.uo" />
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {dataa[0].numberOfUOs}
                                                        </Table.Cell>
                                                    </Table.Row>}
                                                    {/* {data.map(el => */}
                                                    {/*    (<Table.Row > */}
                                                    {/*        <Table.Cell verticalAlign="middle"> */}
                                                    {/*            {el.mark} */}
                                                    {/*        </Table.Cell> */}
                                                    {/*        <Table.Cell verticalAlign="middle"> */}
                                                    {/*            {el.count} */}
                                                    {/*        </Table.Cell> */}
                                                    {/*    </Table.Row>))} */}
                                                </Table.Body>
                                                <Table.Footer>
                                                    <Table.Row>
                                                        <Table.HeaderCell>
                                                        </Table.HeaderCell>
                                                        <Table.HeaderCell>
                                                            <h4><FormattedMessage id="professorInputGrades.averageGrade" /> {dataa[0].averageGrade}</h4>
                                                        </Table.HeaderCell>

                                                    </Table.Row>
                                                </Table.Footer>
                                            </Table>
                                        </div>
                                            : <Fragment>
                                                <FormattedMessage id="professorInputGrades.noDataForAcademicYear" />
                                            </Fragment>}
                                    {/* </Segment.Group > */}
                                </Grid.Column>

                                <Grid.Column>
                                    <Divider horizontal>
                                        <Header as="h4"><FormattedMessage id="professorStatistics.graphicShow" /><br />
                                        </Header>
                                    </Divider>
                                    {this.state.loading ? <Segment><div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div></Segment> :
                                        this.state.dataa.length ?
                                            <Fragment>
                                                <PieChart style={center} width={400} height={300}>
                                                    <Pie
                                                        data={chartData}
                                                        innerRadius={20}
                                                        outerRadius={100}
                                                        paddingAngle={5}
                                                        dataKey="count"
                                                        nameKey="displayName"
                                                    >
                                                        {
                                                            chartData.map((entry, index) => <Cell fill={colors[index % colors.length]} />)
                                                        }
                                                    </Pie>
                                                    <Legend iconType="circle" iconSize={15} width={160} height={140} layout="vertical" align="left" verticalAlign="bottom" wrapperStyle={legendStyle} />

                                                    <Tooltip />
                                                </PieChart>
                                            </Fragment> :
                                            <Fragment>
                                                <FormattedMessage id="professorInputGrades.noDataForAcademicYear" />
                                            </Fragment>}

                                    {/* </Segment.Group> */}
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row stretched>
                                <Grid.Column>
                                    {this.state.loading ? <Segment><div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div></Segment> :
                                        dataa.length ? <Fragment>
                                            <Table size="small" celled selectable compact>
                                                <Table.Header>
                                                    <Table.Row>
                                                        <Table.HeaderCell>
                                                            <FormattedMessage id="professorStatistics.numberOfStudentsOnCourse" />
                                                        </Table.HeaderCell>
                                                        <Table.HeaderCell>
                                                            <FormattedMessage id="professorStatistics.numberOfDistinctStudentGradedActivities" />
                                                        </Table.HeaderCell>
                                                        <Table.HeaderCell>
                                                            <FormattedMessage id="professorStatistics.numberOfExamRegistrations" />
                                                        </Table.HeaderCell>
                                                        <Table.HeaderCell>
                                                            <FormattedMessage id="professorStatistics.numberOfDistinctStudentsWhoAccessedExam" />
                                                        </Table.HeaderCell>
                                                        <Table.HeaderCell>
                                                            <FormattedMessage id="professorStatistics.numberOfStudentsWhoAccessedExam" />
                                                        </Table.HeaderCell>
                                                        <Table.HeaderCell>
                                                            <FormattedMessage id="professorStatistics.numberOfStudentsWhoPassed" />
                                                        </Table.HeaderCell>
                                                        <Table.HeaderCell>
                                                            <FormattedMessage id="professorStatistics.averagePassed" />
                                                        </Table.HeaderCell>
                                                    </Table.Row>
                                                </Table.Header>
                                                <Table.Body>
                                                    {dataa.map(el =>
                                                        (<Table.Row >
                                                            <Table.Cell verticalAlign="middle">
                                                                {el.numberOfStudentsOnCourse}
                                                            </Table.Cell>
                                                            <Table.Cell verticalAlign="middle">
                                                                {el.numberOfDistinctStudentGradedActivities}
                                                            </Table.Cell>
                                                            <Table.Cell verticalAlign="middle">
                                                                {el.numberOfExamRegistrations}
                                                            </Table.Cell>
                                                            <Table.Cell verticalAlign="middle">
                                                                {el.numberOfDistinctStudentsWhoAccessedExam}
                                                            </Table.Cell>
                                                            <Table.Cell verticalAlign="middle">
                                                                {el.numberOfStudentsWhoAccessedExam}
                                                            </Table.Cell>
                                                            <Table.Cell verticalAlign="middle">
                                                                {el.numberOfStudentsWhoPassed}
                                                            </Table.Cell>
                                                            <Table.Cell verticalAlign="middle">
                                                                <strong>{el.averagePassed} %</strong>
                                                            </Table.Cell>
                                                        </Table.Row>))}
                                                </Table.Body>
                                            </Table>
                                        </Fragment>
                                            : ''}
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Segment>
                </Segment.Group>

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/Courses/CourseStatistics.js